export function strengthColor(code: number, didnotmatch?: boolean){

    if (code === 0 || didnotmatch) return 'rgb(228, 8, 8)';

    if (code === 1) return 'rgb(255, 216, 0)';

    if (code === 2) return 'rgb(44, 177, 23)';

    if (code === 3) return 'rgb(44, 228, 23)';

    return 'rgb(208, 201, 202)';

}